import $ from 'jquery';
import '@chenfengyuan/datepicker/dist/datepicker.esm.js';

$.fn.datepicker.languages['de-CH'] = {
    format: 'dd.mm.yyyy',
    days: ['Sonntag', 'Montag', 'Dienstag', 'Mittwoch', 'Donnerstag', 'Freitag', 'Samstag'],
    daysShort: ['So', 'Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa'],
    daysMin: ['So', 'Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa'],
    months: [
        'Januar',
        'Februar',
        'März',
        'April',
        'Mai',
        'Juni',
        'Juli',
        'August',
        'September',
        'Oktober',
        'November',
        'Dezember',
    ],
    monthsShort: ['Jan', 'Feb', 'Mär', 'Apr', 'Mai', 'Jun', 'Jul', 'Aug', 'Sep', 'Okt', 'Nov', 'Dez'],
    weekStart: 1,
    startView: 0,
    yearFirst: false,
    yearSuffix: '',
};

$.fn.datepicker.setDefaults({
    format: 'dd.mm.yyyy',
    autoHide: true,
    language: 'de-CH',
});
